import {
  GET_PAGES,
  PAGE_ERRORS,
  GET_SECURED_PAGES,
  GET_MENU_PAGES,
  PAGES_LOADING,
  GET_PAGE,
  RESET_PAGES,
  GET_CONTENT_ROWS,
  GET_CONTENT_ROW,
} from '../actions/types'

const initialState = {
  menu: null,
  pages: null,
  page: null,
  content_rows: null,
  content_row: null,
  loading: true,
  errors: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case PAGES_LOADING:
      return {
        ...state,
        loading: true,
      }
    case GET_PAGES:
      return {
        ...state,
        pages: action.payload,
        loading: false,
      }
    case GET_SECURED_PAGES:
      return {
        ...state,
        pages: action.payload,
        errors: null,
        loading: false,
      }
    case GET_MENU_PAGES:
      return {
        ...state,
        menu: action.payload,
        errors: null,
        loading: false,
      }
    case GET_PAGE:
      return {
        ...state,
        page: action.payload,
        errors: null,
        loading: false,
      }
    case GET_CONTENT_ROWS: {
      return {
        ...state,
        content_rows: action.payload,
        errors: null,
        loading: false,
      }
    }
    case GET_CONTENT_ROW: {
      return {
        ...state,
        content_row: action.payload,
        errors: null,
        loading: false,
      }
    }
    case RESET_PAGES:
      return {
        ...state,
        page: null,
        pages: null,
        objects: null,
        content_rows: null,
        content_row: null,
        errors: null,
        loading: true,
      }
    case PAGE_ERRORS:
      return {
        loading: false,
        errors: action.payload,
      }
    default:
      return state
  }
}
